import { render, staticRenderFns } from "./DirectCom.vue?vue&type=template&id=ceb2a29a&scoped=true&"
import script from "./DirectCom.vue?vue&type=script&lang=js&"
export * from "./DirectCom.vue?vue&type=script&lang=js&"
import style0 from "./DirectCom.vue?vue&type=style&index=0&id=ceb2a29a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceb2a29a",
  null
  
)

export default component.exports